import React from "react";
import FAQ from "../Home/Homefaqs";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import AppDownload from "../Home/AppDownload";
import styles from "./Faqs.module.css"
import ExpertsFaqs from "../Home/ExpertsFaqs";

function Faqs() {
  return (
    <div>
      <Navbar/>
      <section className={styles.AboutusheroSection}>
        <h1>Everything You Need to Know About UpTik</h1>
      </section>
      <FAQ />
      {/* <ExpertsFaqs/> */}
      <AppDownload/>
      <Footer />
    </div>
  );
}

export default Faqs;
